import * as React from 'react';
import { MyLinksStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { IATextField } from '../../textField/TextField';

import { LocalizationService } from '../../../services/LocalizationService';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../../global';
import { IAIconPicker } from '../../iconPicker/IconPicker';
import { IAButton } from '../../button/Button';

export interface IProps {
  myLinksStore?: MyLinksStore;
  open: boolean;
  onSave: () => void;
}

export interface IState {
}

@inject('myLinksStore')
@observer
export class EditPanel extends React.Component<IProps, IState> {

  private localizationService = new LocalizationService()

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
  }

  // private validateUrl(url: string): boolean {
  //   var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
  //     '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  //     '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  //     '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  //   return pattern.test(url);
  // }

  private getPageTitle(url: string): Promise<string> {
    return new Promise((resolve) => {
      const apiUrl = `https://rss.api.intraactive.net/content?url=${encodeURIComponent(url)}`;
      new FetchProxy(apiUrl, {
        method: "GET",
        credentials: "same-origin",
        mode: "cors",
      }).withContainer(sdkContainerInstance)
        .fetch()
        .then((response: any) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.text()
          }
        }).then(response => {
          var contentDiv: any = document.createElement('div');
          contentDiv.innerHTML = response;
          if (contentDiv && contentDiv.getElementsByTagName("title") && contentDiv.getElementsByTagName("title")[0]) {
            resolve(contentDiv.getElementsByTagName("title")[0].innerHTML);
          } else {
            resolve("");
          }
        })
    });
  }

  public render(): JSX.Element {
    const disableSaving = !(this.props.myLinksStore.itemToEdit &&
      this.props.myLinksStore.itemToEdit.title &&
      this.props.myLinksStore.itemToEdit.title !== "" &&
      this.props.myLinksStore.itemToEdit.url &&
      this.props.myLinksStore.itemToEdit.url !== ""
    );
    if (this.props.myLinksStore.itemToEdit && !this.props.myLinksStore.itemToEdit.icon) {
      this.props.myLinksStore.itemToEdit.icon = this.props.myLinksStore.defaultLinkIcon;
    }
    const content = (
      <div style={{
        padding: "0 40px"
      }}>
        <IATextField
          label={`${this.localizationService.strings.MyLinks_LinkUrl}*`}
          text={this.props.myLinksStore.itemToEdit ? this.props.myLinksStore.itemToEdit.url : undefined}
          borderRadius={5}
          onChange={(url: string) => {
            this.props.myLinksStore.itemToEdit.url = url;
            // this.props.myLinksStore.validUrl = this.validateUrl(url);
            url = encodeURI(url);
            // if (this.props.myLinksStore.validUrl) {
            this.getPageTitle(url).then((pageTitle: string) => {
              if (pageTitle && pageTitle !== "" && (this.props.myLinksStore.itemToEdit.title === "" || this.props.myLinksStore.itemToEdit.title === undefined)) {
                this.props.myLinksStore.itemToEdit.title = pageTitle;
                this.forceUpdate();
              }
            });
            // }
            this.forceUpdate();
          }
          }
        />
        <IATextField
          label={`${this.localizationService.strings.MyLinks_LinkTitle}*`}
          borderRadius={5}
          text={this.props.myLinksStore.itemToEdit ? this.props.myLinksStore.itemToEdit.title : undefined}
          onChange={(title: string) => {
            this.props.myLinksStore.itemToEdit.title = title;
            this.forceUpdate();
          }}
        />
        <IAIconPicker
          label={`${new LocalizationService().strings.ContentCreatorAdmin_SelectIcon}*`}
          selectedIcon={this.props.myLinksStore.itemToEdit ? this.props.myLinksStore.itemToEdit.icon : undefined}
          color={this.props.myLinksStore.highlightColor}
          select={(icon: string) => {
            this.props.myLinksStore.itemToEdit.icon = icon;
            this.forceUpdate();
          }}
          shouldBeAbleToClear={false}
          clear={() => { }}
        />
        <IAButton
          label={this.localizationService.strings.MyLinks_Save}
          style={{
            marginTop: 20,
            float: "right",
            clear: "both"
          }}
          borderRadius={5}
          buttonColor={this.props.myLinksStore.highlightColor}
          arialable="Save"
          disbaled={disableSaving || this.props.myLinksStore.isSaving}
          onClick={() => {
            this.save().then(() => {
              this.props.onSave();
              this.close();
            });
          }}
        />


      </div>
    )
    return (
      <IAPanel
        showNavigationBar={true}
        title={this.props.myLinksStore.isCreatingNewItem ? this.localizationService.strings.MyLinks_PanelTitleCreate : this.localizationService.strings.MyLinks_PanelTitleEdit}
        component={"ContentCreator"}
        open={!!this.props.myLinksStore.itemToEdit}
        transition="slide"
        width={window.innerWidth < 667 ? window.innerWidth : 600}
        isMobile={false}
        highlightColor={this.props.myLinksStore.highlightColor}
        marginTop={this.props.myLinksStore.marginTop ? this.props.myLinksStore.marginTop : 0}
        disableSaving={disableSaving || this.props.myLinksStore.isSaving}
        close={() => {
          if (this.props.myLinksStore.itemToEdit && this.props.myLinksStore.itemToEdit.title != undefined && this.props.myLinksStore.itemToEdit.title != "") {
            this.props.myLinksStore.showCancelEditPopup = true;
          } else {
            this.close();
          }
        }}
        onDelete={(this.props.myLinksStore.itemToEdit && !this.props.myLinksStore.isCreatingNewItem) ? () => {
          this.props.myLinksStore.showDeletePopup = true;
        } : undefined}
      >{content}</IAPanel>
    );
  }

  private close(): void {
    this.props.myLinksStore.itemToEdit = undefined;
    this.props.myLinksStore.isCreatingNewItem = false;
  }

  private save(): Promise<void> {
    return new Promise<void>((resolve: () => void): void => {
      this.props.myLinksStore.isSaving = true;
      if (this.props.myLinksStore.isCreatingNewItem) {
        this.props.myLinksStore.myLinks.push(this.props.myLinksStore.itemToEdit);
      }
      setTimeout(() => {
        this.props.myLinksStore.isSaving = false;
        resolve();
      }, 500);
    });
  }


}